import {httpService, HttpWrapperOptions} from '../../shared/httpWrapper';
import {getApiRoute} from '../../shared/pipes';
import {apiUrls} from '../../shared/constants/urls';
import View from './view';
import querystring from 'query-string';
import React from 'react';

import {useAppDispatch} from '../../redux';
import {getProfileSettings} from '../../redux/actions/profile';

export const SmsEmailSubscriptionControlScreen = () => {
  const {code} = querystring.parse(window.location.search.replace('?', ''));
  const [isSuccess, setSuccess] = React.useState(false);
  const dispatch = useAppDispatch();

  const onSubmitHandle = async (isEmail: boolean, isSms: boolean) => {
    if (!code) {
      return;
    }
    await httpService.post(
      getApiRoute(apiUrls.postUnsubscribeSmsEmail),
      {code: code, disableEmail: isEmail, disableSms: isSms},
      new HttpWrapperOptions().ThrowException(true).Errors(true),
    );
    dispatch(getProfileSettings());
    setSuccess(true);
  };

  return View({onSubmitHandle, isSuccess});
};
